import React, { useState, useContext } from "react"; // Import useContext
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { LanguageContext } from "../context/LanguageContext"; // Import LanguageContext

function Signup() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    number: "",
  });

  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [rePassword, setRepassword] = useState("");

  const { language } = useContext(LanguageContext); // Consume LanguageContext

  // --- Translatable Content Definitions ---
  const enContent = {
    signupTitle: "Sign Up",
    fullNameLabel: "Full Name",
    emailLabel: "Email",
    passwordLabel: "Password",
    repeatPasswordLabel: "Repeat Password",
    phoneNumberLabel: "Phone Number",
    createAccountButton: "Create Account",
    passwordsMismatch: "Passwords do not match",
    signupFailed: "Signup failed.",
    accountCreated: "🎉 Account created! You can now login.",
    somethingWentWrong: "Something went wrong.",
    alreadyHaveAccountPrompt: "Already have an account?",
    loginLink: "Login",
  };

  const urContent = {
    signupTitle: "سائن اپ کریں", // Sign Up
    fullNameLabel: "پورا نام", // Full Name
    emailLabel: "ای میل", // Email
    passwordLabel: "پاس ورڈ", // Password
    repeatPasswordLabel: "پاس ورڈ دوبارہ درج کریں", // Repeat Password
    phoneNumberLabel: "فون نمبر", // Phone Number
    createAccountButton: "اکاؤنٹ بنائیں", // Create Account
    passwordsMismatch: "پاس ورڈز مماثل نہیں ہیں۔", // Passwords do not match
    signupFailed: "سائن اپ ناکام رہا۔", // Signup failed.
    accountCreated: "🎉 اکاؤنٹ بن گیا! اب آپ لاگ ان کر سکتے ہیں۔", // Account created! You can now login.
    somethingWentWrong: "کچھ غلط ہو گیا۔", // Something went wrong.
    alreadyHaveAccountPrompt: "پہلے سے ہی اکاؤنٹ ہے؟", // Already have an account?
    loginLink: "لاگ ان کریں", // Login
  };

  const content = language === "en" ? enContent : urContent;
  // --- End Translatable Content Definitions ---

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (formData.password !== rePassword) {
      setError(content.passwordsMismatch); // Use translated message
      return;
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/register`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await res.json();
      console.log("Signup response:", res.status, data);

      if (!res.ok) {
        setError(data.message || content.signupFailed); // Use translated message
        return;
      }

      setMessage(content.accountCreated); // Use translated message
      setFormData({ name: "", email: "", password: "", number: "" });
      setRepassword(""); // Clear repeat password too
    } catch (err) {
      console.error(err);
      setError(err.message || content.somethingWentWrong); // Use translated message
    }
  };

  return (
    <Box
      className="signup-container"
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5", // optional background
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Typography variant="h3" gutterBottom color="black" textAlign="center">
          {content.signupTitle} 
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            backgroundColor: "white",
            p: 4,
            borderRadius: 2,
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <TextField
            label={content.fullNameLabel} 
            name="name"
            value={formData.name}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            label={content.emailLabel}
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            label={content.passwordLabel} 
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            label={content.repeatPasswordLabel} 
            name="repassword"
            type="password"
            value={rePassword}
            onChange={(e) => setRepassword(e.target.value)}
            fullWidth
            required
          ></TextField>

          <TextField
            label={content.phoneNumberLabel} 
            name="number"
            type="tel"
            value={formData.number}
            onChange={(e) => {
              const onlyNums = e.target.value.replace(/[^0-9]/g, "");
              setFormData((prev) => ({ ...prev, number: onlyNums }));
            }}
            fullWidth
            required
            InputProps={{
              maxLength: 15,
              inputMode: "numeric",
            }}
          />

          <Button variant="contained" type="submit">
            {content.createAccountButton}
            </Button>
        </Box>

        {message && (
          <Alert severity="success" sx={{ mt: 2 }}>
            {message}
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}

        <Typography variant="body1" sx={{ mt: 3 }} textAlign="center">
          {content.alreadyHaveAccountPrompt}{" "}
          <a href="/login">
            {content.loginLink} {/* Translated link text */}
          </a>
        </Typography>
      </Container>
    </Box>
  );
}

export default Signup;